import templateStr from 'text!./policy-transaction.html';
import JobUtil from 'edge/gateway/util/JobUtil';
import 'portalConfig';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            displayType: '@',
            accountNumber: '@',
            policyNumber: '@',
            status: '=',
            search: '='
        },
        controller: ['$q', 'ModalService', '$scope', 'AccountService', 'PolicyService', '$window', '$filter', 'InsuranceSuiteMetadata', 'GPA_PC_ENTRY_POINT', function ($q, ModalService, $scope, AccountService, PolicyService, $window, $filter, InsuranceSuiteMetadata, GPA_PC_ENTRY_POINT) {
            var policyTransactions = [];
            $scope.loading = true;
            $scope.jobUtil = JobUtil;

            getPolicyTransactionsFromXCenter();

            $scope.getFilteredPolicyTransactions = function () {
                if (!policyTransactions) {
                    return [];
                }

                var transactions = policyTransactions;

                if ($scope.status) {
                    transactions = $filter('filter')(transactions, transactionStatusFilter);
                }
                if ($scope.search) {
                    transactions = $filter('filter')(transactions, $scope.search);
                }

                return transactions.sort(function (a, b) {
                    return new Date(b.policyEffectiveDate).getTime() - new Date(a.policyEffectiveDate).getTime();
                });
            };

            function getPolicyTransactionsFromXCenter() {
                if (displayTypeIsValid()) {
                    var transactionsPromise = getPolicyTransactionPromise();
                    $scope.transactionsPromise = transactionsPromise;

                    $q.when(transactionsPromise, function (transactions) {
                        $scope.loading = false;
                        policyTransactions = transactions;
                    }, function () {
                        $scope.failedToGetJobs = true;
                        ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
                    });
                }
            }

            function displayTypeIsValid() {
                if ($scope.displayType.toLowerCase() === 'account' || $scope.displayType.toLowerCase() === 'policy') {
                    return true;
                }
                throw new Error({
                    'message': 'display-type must either be account or policy'
                })();
            }

            function getPolicyTransactionPromise() {
                if ($scope.displayType === 'account') {
                    return AccountService.getOpenPolicyTransactionsForAccount($scope.accountNumber);
                } else if ($scope.displayType === 'policy') {
                    return PolicyService.getPolicyTransactionsForPolicy($scope.policyNumber);
                }
            }

            function transactionStatusFilter(transaction) {
                if ($scope.status) {
                    if ($scope.status === 'all') {
                        return true;
                    } else if (transaction.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode($scope.status).name) {
                        return true;
                    }
                    return false;
                }
                return true;
            }

            $scope.openJobInXCenter = function (jobNumber) {
                JobUtil.openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber);
            };

            $scope.userCanOpenJobInXCenter = function (transaction) {
                return transaction.canUserView && transactionTypeIsViewableInXCenter(transaction);
            };

            function transactionTypeIsViewableInXCenter(transaction) {
                return transaction.type.toLowerCase() !== 'reinstatement' && transaction.type.toLowerCase() !== 'rewrite';
            }

            $scope.canShowOnThisPage = function (view) {
                return view.toLowerCase() === $scope.displayType.toLowerCase();
            };

            $scope.hidePolicyNumber = function (transaction) {
                return transaction.status.toLowerCase() === 'draft' && transaction.type.toLowerCase() === 'submission' || !transaction.policyNumber;
            };

            $scope.showOpenJobInXCenter = function (item) {
                return item.type !== 'Submission' && item.type !== 'PolicyChange' && item.type !== 'Cancellation' && item.type !== 'Renewal';
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PolicyTransactionsDirective/PolicyTransactions.js
// module id = 1760
// module chunks = 0